import { ClippingStudioClip } from "app/js/src/domain/clipping-studio/clipping-studio-clip";
import { AppendedMamSegment } from "app/js/src/domain/clipping-studio/clipping-studio-project";

/**
 * Source-timeline start (ms) of an appended MAM segment, matching
 * ConvertVideoSegmentsForRender / BuildAppendedMamWindows on the backend.
 */
export function getAppendedMamWindowStartMs(
  appendedSegmentId: string,
  appended: AppendedMamSegment[],
  mainDurationMs: number,
): number | null {
  if (!appendedSegmentId || mainDurationMs < 0) {
    return null;
  }
  let cursorMs = mainDurationMs;
  for (const segment of appended ?? []) {
    if (segment.id === appendedSegmentId) {
      return cursorMs;
    }
    cursorMs += Math.max(0, segment.durationMs ?? 0);
  }
  return null;
}

/**
 * Maps a global source-timeline time to time within the MAM media file.
 * Same contract as render: with appendedSegmentId → sourceTime - window.StartMs;
 * edit-only full MAM add (no appendedSegmentId) → sourceTime - clip.inMs.
 */
export function resolveMamFileTimeMs(
  sourceTimeMs: number,
  clip: ClippingStudioClip,
  appended: AppendedMamSegment[],
  mainDurationMs: number,
): number {
  if (clip.appendedSegmentId) {
    const windowStart = getAppendedMamWindowStartMs(
      clip.appendedSegmentId,
      appended,
      mainDurationMs,
    );
    if (windowStart != null) {
      return Math.max(0, sourceTimeMs - windowStart);
    }
  }
  return Math.max(0, sourceTimeMs - (clip.inMs ?? 0));
}

/**
 * Source-mode video track should show main cuts and cuts from appended MAM
 * (appendedSegmentId set). Hide only whole-file MAM clips added in Edit mode.
 */
export function isVisibleOnSourceTimeline(clip: ClippingStudioClip): boolean {
  return clip.mamMediaId == null || clip.appendedSegmentId != null;
}
